



















































































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    carouselModal: require '../modal_carousel.vue'
    triggerStages: require './trigger_stages.vue'
    propertiesMatching: require './properties_matching.vue'
    propertiesSelect: require './properties_select.vue'
    propertiesTable: require './properties_table.vue'
    stagesSelect: require '../../shared/dropdown_multiple_kind/stage_filter.vue'

  data: ->
    status:false
    property: null
    property_id: null
    current_user: Session.current_user
    rd_carousel: null
    show_carousel: false
    show_id: false
    custom_field_id: null
    use_carousel: false
    show_user_carousel:false
    rd_station_setting: if Session.current_user.rd_station_setting.id? then Session.current_user.rd_station_setting else new RdStationSetting()
    selectedSaleRD: Session.current_user.rd_station_setting?.mark_lead_as_sale
    selectedLostRD: Session.current_user.rd_station_setting?.mark_lead_as_lost
    selectedOpportunityRD: Session.current_user.rd_station_setting?.mark_lead_as_opportunity
    copied_rd: false
    rdstation_authorized: Session.current_user.rd_station_setting?.authorized
    show_form_rd: false
    url_fields: 'https://api.rd.services/platform/contacts/fields'
    api_fields: []
    matching: []
    filter_item_selected_ids: [],

  mounted: ->
    if @$route.query.setting == "rd_station"
      @show_form_rd = true
    
      if !@rdstation_authorized
        @redirectToRdstationOauthUrl()

    if Session.current_user.rd_station_setting.id?
      @rd_station_setting = Session.current_user.rd_station_setting
    else
      @rd_station_setting = new RdStationSetting()
    
    @custom_field_id = @rd_station_setting.custom_field_id
    if @rd_station_setting.use_carousel == true
      @use_carousel = true
      @show_carousel = false
      @show_user_carousel= false 
      
    else if @rd_station_setting.use_carousel_by_property == true
      @show_id = true
      @show_carousel = true
      @use_carousel = false
      @show_user_carousel= false
      
    else if @rd_station_setting.use_carousel_by_property == false && @rd_station_setting.use_carousel == false
      @show_user_carousel= true
      @show_carousel = false
      @use_carousel = false

    Tooltip.initialize()
    @loadFields()
  
  computed:      

    use_carousel: ->
      if @use_carousel == true && @show_carousel == false && @show_user_carousel == false
          
        @updateRdStationSetting()

    show_carousel: ->
      if @show_carousel == true && @use_carousel == false  && @show_user_carousel == false

        @updateRdStationSetting()

    show_user_carousel: ->
      if @show_carousel == false && @use_carousel == false && @show_user_carousel == true
    
        @updateRdStationSetting()


  methods:

    itemSelectedItems: (data) ->
      @rd_station_setting.triggers.stages = data

    setStages: (data) ->
      this.setting.triggers = data

    property_id_updated: (id) ->
      @property_id = id
    property_updated: (property)->
      @property = property
      @$store.commit 'table', @property
    
    use_carousel_rd: ->
      if @rd_station_setting.use_carousel
        return this.$t('integrations.label.contactsViaCarousel')
      this.$t('integrations.label.contactsViaResponsible')

    checkboxSelectSaleRD: ->
      return if !@rdstation_authorized && @rd_station_setting.use_carousel
      @selectedSaleRD = !@selectedSaleRD
      @updateStages()

    checkboxSelectLostRD: ->
      return if !@rdstation_authorized && @rd_station_setting.use_carousel
      @selectedLostRD = !@selectedLostRD
      @updateStages()

    checkboxSelectOpportunityRD: ->
      return if !@rdstation_authorized && @rd_station_setting.use_carousel
      @selectedOpportunityRD = !@selectedOpportunityRD
      @updateStages()

    updateStages: ->
      @rd_station_setting.triggers.stages.push('client') if @selectedSaleRD && (@rd_station_setting.triggers.stages.indexOf('client') < 0)
      @rd_station_setting.triggers.stages.push('lost') if @selectedLostRD && (@rd_station_setting.triggers.stages.indexOf('lost') < 0)
      @rd_station_setting.triggers.stages.push('opportunity') if @selectedOpportunityRD && (@rd_station_setting.triggers.stages.indexOf('opportunity') < 0)

    fillRdCarousel: (carousel) ->
      @rd_carousel = carousel

    loadRdCarouselData: ->
      @$refs.rd_carousel_modal.loadData()

    open: () ->
      @show_form_rd = true
      @$router.push({ path: "/configuracoes/integracao?setting=rd_station" })

    connect: () ->
      Loader.on()
      @redirectToRdstationOauthUrl()

    copyURLrd: ->
      jQuery('#rd_url').select()
      document.execCommand("copy")
      @copied_rd = true

    updateRdStationSetting: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        rd_station_setting_attributes: {
          id: @rd_station_setting.id,
          mark_lead_as_sale: @selectedSaleRD,
          mark_lead_as_lost: @selectedLostRD,
          mark_lead_as_opportunity: @selectedOpportunityRD,
          use_carousel: @rd_station_setting.use_carousel,
          custom_field_id: @rd_station_setting.custom_field_id,
          use_carousel_by_property: @rd_station_setting.use_carousel_by_property,
          triggers: @rd_station_setting.triggers,
          use_new_ui: Session.current_user.new_ui
        }
      }
      new UsersResource().update(@updateRdstationSettingSuccess, @handleApiErrors, params)
      # custom_field_id
    redirectToRdstationOauthUrl: ->
      if @rdstation_authorized
        Loader.on()
        params = {
          id: Session.current_user.id,
          rd_station_setting_attributes: {
            id: @rd_station_setting.id,
            _destroy: 1
          }
        }
        new UsersResource().update(@updateRdstationSettingSuccess, @handleApiErrors, params)
        @rdstation_authorized = false
        alertify.success this.$t('integrations.feedback.rdStationDisconnectSuccess')
        intercom_event_name = this.$t('integrations.feedback.rdStationDisconnectEvent')
        IntercomCtrl.trackEvent(intercom_event_name)
        @$router.push({ path: "/configuracoes/integracao" })
      else
        Loader.on()
        return window.parent.postMessage({ type: "redirect-integration", route: @rdStationOauthUrl }, "*") if window.parent && Session.current_user.new_ui
        window.location = @rdStationOauthUrl

    updateRdstationSettingSuccess: (data, response) ->
      Loader.off()
      alertify.success this.$t('general.feedback.settingUpdated')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @rd_station_setting = Session.current_user.rd_station_setting

    toggleUserCarouselRd: ->

      if @rd_station_setting.use_carousel_by_property == true 
        show_carousel= true
        @show_id = true
      @property= null 
      @show_id = true
      @show_carousel = !@show_carousel
      @rd_station_setting.use_carousel_by_property = true
      @rd_station_setting.use_carousel = false
      @use_carousel= false
      @show_user_carousel = false
      
    toggleUseCarouselRd: ->
      if @rd_station_setting.use_carousel == true
        @use_carousel= true
      else
        @use_carousel = !@use_carousel
      @rd_station_setting.use_carousel = true
      @rd_station_setting.use_carousel_by_property = false
      @show_carousel = false
      @show_user_carousel=false
      
     
    toggleUseResponsibleRd: ->

      if @rd_station_setting.use_carousel_by_property == false && @rd_station_setting.use_carousel == false
        @show_user_carousel= true
      @rd_station_setting.use_carousel = false
      @rd_station_setting.use_carousel_by_property = false
      @use_carousel = false
      @show_carousel = false
      @show_user_carousel= !@show_user_carousel

    modalTitle: ->
      if @current_user.isSeller() then this.$t('integrations.attributes.Carousel') else this.$t('integrations.label.setCarousel')
    
    loadCarousel: (data) ->
      new CarouselPropertyResource().show(@loadCarouselSuccess, @loadCarouselFailure, params: { q:{kind_eq:2} })

    loadCarouselSuccess: (data) ->
      if  data != undefined && Object.keys(data).length > 0 && data != null && @rd_station_setting.use_carousel == false
        @custom_field_id = data[0].custom_field_id
        
    loadCarouselFailure: (data) ->
      if data.status == 404
        @carousel = new Carousel

      else
      @unknownError

    loadFields: ->
      return if !@rdstation_authorized && (@rd_station_setting.use_carousel || @rd_station_setting.use_carousel_by_property)
      self = @
      Vue.http.get("#{process.env.API_URL}/rd_station/contact_properties")
        .then((response) -> 
          fields = response.data.fields.filter (field) -> field.api_identifier != 'name' and field.api_identifier != 'email'
          if !Array.isArray self.rd_station_setting.properties_matching
            self.rd_station_setting.properties_matching = new RdStationSetting().properties_matching
          self.api_fields = fields.map((field) -> {
            type: self.getTypeField(field.data_type), key: field.api_identifier, name: if field.custom_field then field.name.default else field.label.default
          }).sortByKey('name')
        )
        .catch((error) ->
          alertify.error this.$t('integrations.feedback.expiredAuth')
        )

    closeForm: ->
      @$router.push path: '/configuracoes/integracoes'

    getTypeField: (data) ->
      'text'

    matchingUpdated: (data) ->
      @matching = data

    save: ->
      @rd_station_setting.use_carousel_by_property = @show_carousel
      @rd_station_setting.use_carousel = @use_carousel
      @rd_station_setting.properties_matching = @matching
      @rd_station_setting.mark_lead_as_sale = @selectedSaleRD
      @rd_station_setting.mark_lead_as_lost = @selectedLostRD
      @rd_station_setting.mark_lead_as_opportunity = @selectedOpportunityRD
      @rd_station_setting.custom_field_id = @property_id
      Loader.on()
      params = {
        id: Session.current_user.id,
        rd_station_setting_attributes: @rd_station_setting
      }
      new UsersResource().update(@updateSuccess, @handleApiErrors, params)
      @closeForm()

    updateSuccess: (data, response) ->
      Loader.off()
      alertify.success this.$t('integrations.feedback.databaseSuccess')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @rd_station_setting.stage_id = data.user.rd_station_setting.stage_id

  computed:
    rd_url: ->
      if @has_configured_rd_carousel || !@rd_station_setting.use_carousel || @current_user.company.rd_carousel?.id
        process.env.API_URL + '/webhooks/rd_station/import_contacts?token=' + @current_user.authentication_token
      else
        this.$t('integrations.feedback.sharpspringNeedsCarousel')

    rdStationOauthUrl: ->
      client_id = if Session.current_user.new_ui then process.env.RDSTATION_BETA_CLIENT_ID else process.env.RDSTATION_CLIENT_ID

      params = jQuery.param(
        client_id: client_id
        redirect_url: "#{window.location.protocol}//#{window.location.host}/configuracoes/integracoes"
        state: 'rdstation'
      )
      "https://api.rd.services/auth/dialog?#{params}"
    

    has_configured_rd_carousel: ->
      @rd_carousel? && @rd_carousel.carousel_users.length > 0

  created: ->
    @loadCarousel()      


exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/rd_station.vue